export const POSTS_TAB_LOADING_MORE = 'posts-tab.loading-more';
